import api from './api';

export function listTags(workspaceId, botId) {
  return api
    .get(`/workspaces/${workspaceId}/bot-conversations/${botId}/tags`)
    .then((r) => r.data.items);
}

export function createTag(workspaceId, botId, name) {
  return api
    .post(`/workspaces/${workspaceId}/bot-conversations/${botId}/tags`, { name })
    .then((r) => r.data.name);
}
